import { apiClientWithRefreshToken } from "@/api/apiClient";
import { Payslip } from "@/v2/types";

export default async function DeletePayslip(id: string): Promise<Payslip> {
  const res = await apiClientWithRefreshToken({
    url: `/payslips/${id}`,
    method: "DELETE",
  });

  return res.data;
}
